import * as yup from "yup";

const signUpSchema = (TLDs) => yup.object({
  email: yup.string().email().test({ 
    name: "is-valid-tld", 
    message: "email must have a valid TLD", 
    test: (value) => {
      const [,domain] = value.split('@');
      const tlds = TLDs ?? [];
      return !tlds.includes(domain);
    }
  }).required(),
  privacy: yup.boolean().oneOf([true]).required()
}).required();


export default signUpSchema;
